import MonetaryValue from '@eversports/react-components/primitives/MonetaryValue'
import React from 'react'

import { Localized } from '../../localization/react'
import { UsageLimit, UsageLimitPeriod, UsageLimitType } from '../../typings/Product'

interface Props {
  validUntil?: string | null
  usagesLeft?: number | null
  usages: Array<UsageLimit>
  usageLimitPeriod?: UsageLimitPeriod | null
}

const AssignedProductUsageInformation: React.FC<React.PropsWithChildren<Props>> = ({
  validUntil,
  usagesLeft,
  usages,
  usageLimitPeriod,
}) => {
  const ValidUntil = validUntil ? (
    <Localized id="assigned-product-valid-until" params={{ validUntil: new Date(validUntil) }} />
  ) : null

  const BookingsLeft = usageLimitPeriod ? (
    <Localized
      id="assigned-product-usage-limit-period"
      params={{
        end: new Date(usageLimitPeriod.end),
        remainingBookings: usageLimitPeriod.allowedBookings - usageLimitPeriod.usedBookings,
      }}
    />
  ) : null

  const totalUsagesTypes = usages.filter((usage) => usage.type === UsageLimitType.USAGE_LIMIT_TYPE_TOTAL)

  return (
    <>
      {usagesLeft &&
        totalUsagesTypes.length > 0 &&
        totalUsagesTypes.map((usage, index) => (
          <Localized
            key={`remaining-usage-${index}`}
            id="assigned-product-remaining-usages"
            params={{
              usageLimitUnit: usage.unit as any,
              usagesLeft,
              remainingCredit: usage.currency ? (
                <MonetaryValue value={usagesLeft} currencyCode={usage.currency} />
              ) : null,
            }}
          />
        ))}
      {ValidUntil}
      {BookingsLeft}
    </>
  )
}

export default AssignedProductUsageInformation
